import { render, staticRenderFns } from "./UserPacketsList.vue?vue&type=template&id=6df5a4be&scoped=true&"
import script from "./UserPacketsList.vue?vue&type=script&lang=js&"
export * from "./UserPacketsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df5a4be",
  null
  
)

export default component.exports